import {svgIconWrapper} from '../svg-icon-wrapper';

import NinjaFormsRegular from './ninja-forms-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <NinjaFormsRegular {...rest} />;
}

SvgComponent.iconName = 'ninjaFormsRegular';

export const NinjaFormsRegularIcon = svgIconWrapper(SvgComponent);
